import React from 'react';
import {useNavigate} from 'react-router-dom';
import {AutoReplyCompaniesList, AutoReplySettingsDrawer, getAutoReplyCompanyName, ProfileAlertsBanner} from 'features/profile';
import {ROUTES} from 'app/router/routes';
import styles from './ProfileDataPage.module.css';

const backIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M10 6L4 12L10 18" stroke="currentColor" strokeWidth="1.6" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 12.9135L5 12.9135L5 11.1992L20 11.1992L20 12.9135Z"
			fill="currentColor"
		/>
	</svg>
);

export function ProfileAutoReplyPage(): React.ReactElement {
	const navigate = useNavigate();
	const [selected, setSelected] = React.useState<{id: number; name: string} | null>(null);

	return (
		<div className={styles.root}>
			<header className={styles.header}>
				<button
					type="button"
					className={styles.backButton}
					onClick={() => navigate(ROUTES.profile)}
					aria-label="Назад"
				>
					{backIcon}
				</button>
				<h1 className={styles.title}>Настроить автоотклик</h1>
			</header>

			<div className={styles.content}>
				<div className={styles.contentInner}>
					<ProfileAlertsBanner />
					<AutoReplyCompaniesList
						onSelect={(setting) => {
							if (setting.id == null) {
								return;
							}

							setSelected({id: setting.id, name: getAutoReplyCompanyName(setting)});
						}}
					/>
				</div>
			</div>

			<AutoReplySettingsDrawer
				settingId={selected?.id ?? null}
				previewName={selected?.name}
				onClose={() => setSelected(null)}
			/>
		</div>
	);
}
